<template lang="pug">
.medium-row(
  @click='toggleMediumInSelectedMedia(medium, $event, media, "list"); closeRightClickMenu();',
  @dblclick='handleRowDoubleClick(medium)',
  @contextmenu='openRightClickMenu(medium, $event)',
  :draggable='medium.type !== "PlayListLibraryFolder" && medium.type !== "PlayListLibraryRoot"',
  @dragstart="dragStart(medium, $event)",
  @dragend="dragEnd(medium, $event)",
  @dragenter="dragEnter(medium, $event)"
)
  .cell.thumbnail(:style="{ 'background-image': 'url(' + getThumbnailPath(getFile(medium.File)) + ')' }", @click='playMedium(medium)')
  .cell.medium-name
    .name
      MediumIcon.type-icon(:medium='medium')
      span(:title="medium.name", :class="{ 'warning': isSelectedRight(medium) }") {{medium.name}}
  .cell.tags
    MediumTagsShortInfo(:mediumId='medium.id')
  .cell.params
    .file-info(v-if="!medium.type.startsWith('PlayList')")
      .file-info-row(v-if="getFile(medium.File) && !medium.type.startsWith('PlayList')") {{ getFile(medium.File).originalMimeType }}
      .file-info-row(v-if='getFile(medium.File) && getFile(medium.File).originalWidthPixels') {{ getFile(medium.File).originalWidthPixels }}x{{ getFile(medium.File).originalHeightPixels }}px
      .file-info-row(v-if='!medium.playDurationMs && getFile(medium.File) && getFile(medium.File).originalDurationMs') {{ humanDuration(getFile(medium.File).originalDurationMs) }}
      .file-info-row.warning(v-if="medium.playDurationMs") {{ msToDuration(medium.playDurationMs) }}
      .file-info-row(v-if='getFile(medium.File) && getFile(medium.File).currentSize') {{ humanFileSize(getFile(medium.File).currentSize) }}
  .cell.medium-timeData
    .row(:title='$t("Updated")')
      span {{ $moment(medium.updatedAt).format('YYYY-MM-DD HH:mm') }} &nbsp;
      font-awesome-icon.icon-time(icon="save")
    .row(:title='$t("Created")')
      span {{ $moment(medium.createdAt).format('YYYY-MM-DD HH:mm') }} &nbsp;
      font-awesome-icon.icon-time(icon="folder-plus")
    .row
</template>

<script>
import AssignMixin from '../Linker/assign2.mixin'
import mediaUtils from '../Common/mediaUtils.mixin'
import textUtils from '../Common/textUtils.mixin'
import ListItemMixin from './ListItem.mixin'
import MediumTagsShortInfo from './MediumTagsShortInfo'
import FileShortInfo from './../File/ShortInfo'
import MediumIcon from '../Common/MediumIcon'

export default {
  mixins: [AssignMixin, mediaUtils, textUtils, ListItemMixin],
  props: ['medium', 'media'],
  components: {
    MediumTagsShortInfo,
    FileShortInfo,
    MediumIcon
  },
  created () {
  },
  watch: {
  },
  data () {
    return {
      errors: {
      }
    }
  },
  methods: {
    getFile (arg) {
      return isNaN(arg) ? arg : this.$store.state.File.file_list.find(f => f.id === arg)
    },
    closeRightClickMenu () {
      this.$emit('closeRightClickMenu')
    },
    openRightClickMenu (medium, $event) {
      this.$emit('openRightClickMenu', { medium, $event })
    },
    handleRowDoubleClick (medium) {
      this.loadEditMediumInMediaEditor(medium)
    },
    dragStart (item, event) {
      if (item.type === 'PlayListLibraryFolder' || item.type === 'PlayListLibraryRoot') return
      this.$store.dispatch('Medium/addMediumSelectedLeft', item)
      this.$store.commit('Device/CLEAR_DESKTOPS_SELECTED_RIGHT')
      if (this.$store.state.Medium.media_selected_left.length < 2) return
      const img = new Image()
      img.src = 'static/many-media.svg'
      event.dataTransfer.setDragImage(img, 10, 10)
    },
    // FIXME DRY
    async dragEnd (item, event) {
      if (this.$store.state.Medium.media_selected_right.length === 0 && this.$store.state.Device.desktops_selected_right.length === 0) return
      if (
        this.$store.state.Medium.drop_allowed === true &&
        this.$store.state.Medium.media_selected_right.length > 0 &&
        this.$store.state.User.rightPanelChosen === 'media'
      ) {
        this.$store.dispatch('Medium/setDropAllowed', false)
        await this.assignMediaToPlaylists()
        this.$emit('reloadMediaEditor')
      }

      if (
        this.$store.state.Medium.media_selected_left.length > 0 &&
        this.$store.state.Device.desktops_selected_right.length > 0 &&
        this.$store.state.User.rightPanelChosen === 'devices'
      ) {
        const target = this.$store.state.Medium.local_playlists_cache.find(medium => medium.id === this.$store.state.Device.desktops_selected_right[0].LocalPlayList)
        for (const child of this.$store.state.Medium.media_selected_left) {
          await this.$store.dispatch('Medium/assignMediumToPlaylist', [target.id, child.id])
        }
        this.$emit('reloadLocalPlayLists')
      }
    },
    dragEnter (item, event) {
      this.$store.commit('Device/CLEAR_DESKTOPS_SELECTED_RIGHT')
      this.$store.dispatch('Medium/setDropAllowed', false)
    }
  },
  computed: {
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
  .medium-row {
    display: flex;
    border-bottom: $--border-light;
    align-items: center;
    padding: 0px 5px;
    height: 50px;
    &.selected {
      background-color:  $--background-color-selected;
    }
    .cell {
      padding: 0px 5px;
      overflow: hidden;
      color: $--color-text-regular;
      border: 0px solid red;
      max-height: 50px;
      &.medium-name {
        width: 40%;
        color: $--color-text-primary;
        font-size: $--font-size-small;
        border: 0px solid red;

        .name {
          overflow: hidden;
        }
        .type-icon {
          font-size: 15px;
          margin-right: 10px;
        }
        .mime-type {
          color: $--color-text-secondary;
        }
      }
      &.tags {
        width: 40%;
      }
      &.params {
        width: 10%;
        .file-info-row, .playlist-info-row {
          font-size: $--font-size-small;
          color: $--color-text-secondary;
          padding: 0px 0px;
          &.warning {
            color: $--color-warning;
          }
        }
      }
      &.thumbnail {
        width: 57px;
        height: 57px;
        padding: 0px 0px;
        margin-right: 5px;
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        // border: 1px solid rgba(255,255,255,0);
      }
      &.thumbnail-folder {
        width: 10%;
      }
      &.medium-timeData {
        width: 15%;
        text-align: right;
        .row {
          font-size: $--font-size-small;
          color: $--color-text-secondary;
          padding: 0px 0px;
        }
        .icon-time {
          width: 10px;
          border: 0px solid green;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Medium/MediaRow.vue